(function(){
    'use strict';

    angular.module('swif.openbase')
        .controller('OpenbaseCanadianEditModalCtrl', OpenbaseCanadianEditModalCtrl);

    function OpenbaseCanadianEditModalCtrl($scope,  swif, $window, goNetEndpointApi) {
        /* Set of function used in admin wizard to manage canadian clients*/
        console.log("Init OpenbaseCanadianEditModalCtrl");

        $scope.model = {};
        
        function getMunicipalities()  {
            // Get all municipalities from DB to display it in a table
            swif.data.get("canadian_municipalities").then(function (municipalities) {
                $scope.model.municipalities =  municipalities
            })
        }

        getMunicipalities()

        $scope.searchMuni = function (value) {
            goNetEndpointApi.getGoNetToken()
            // Searching canadian municipalities in Quebec APi
            goNetEndpointApi.getCanadianMuniData(value).success(resp => {
                $scope.municipalities = resp.result.records;
            })
        }

        function getMuniGoNetInfo(token, codemuni ){
            // Get the map service name of the selected municipality
            goNetEndpointApi.getGoNetMapServiceName(token).success(resp => {
                // Get list of all GoNet clients
                resp.find(client => {
                    if (client.codemuni === codemuni){
                        $scope.municipality.map_city_name = client.name;
                        getLayerId(token, client.name);
                    }
                })
            })
        }

        function getLayerId(token, cityName) {
            goNetEndpointApi.getGoNetLayerId(token, cityName).success(result => {
                // Get Layer ID of the selected municipality for map service
                result.layers.find(layer =>{
                    if (layer.name === "Unité d'évaluation" && layer.geometryType === "esriGeometryPolygon"){
                        $scope.municipality.layer_id = layer.id;
                    }
                })
            });
        }

        function checkMuniExist (muni){
            // Check if selected Muni already exist in DB
            let token = $window.localStorage.getItem('token');
            let filter = {}
            swif.data.addFilter(filter, "codemuni", "=", muni.mcode)
            swif.data.get("canadian_municipalities", undefined, filter).then(function (results) {
                if(results.length === 0) {
                    $scope.municipality = {
                        "codemuni": muni.mcode,
                        "address": muni.madr1,
                        "name": muni.munnom
                    }
                    getMuniGoNetInfo(token, muni.mcode)
                } else {
                    alert("Municipality already exist. Please select another one.")
                }
            })
        }

        $scope.selectMunicipalityOnClick = function(municipality) {
            // Get the selected municipality's data from the list
            checkMuniExist(municipality)
            $scope.inputSearch = ""
        }



        /*  Actions' function: create and delete municipality */
        $scope.saveMunicipality = function (municipality){
            // Save municipality in DB
            swif.data.create("canadian_municipalities",  municipality).then(function () {
                swif.message.addInfo("Municipality saved");
                delete $scope.municipalities;
                delete $scope.municipality
                getMunicipalities()
            }, function (error) {
                swif.message.addError(error);
            })
        }

        $scope.deleteMuni =  function (municipality){
            //delete the selected municipality from DB
            swif.data.unlink("canadian_municipalities", [municipality.id]).then(function () {
                getMunicipalities()
            });
        }
    }
})();
